export const SEND_TO_DEVICE_TYPE_WORKOUT = 'workout';
export const SEND_TO_DEVICE_TYPE_COURSE = 'course';
export const SEND_TO_DEVICE_TYPE_SEGMENT = 'segment';
export const SEND_TO_DEVICE_TYPE_PACEPRO = 'pacepro';
export const SEND_TO_DEVICE_TYPE_PERSONAL_RECORD = 'personalRecord';
export const SEND_TO_DEVICE_TYPE_ACTIVITY = 'activity';
export const SEND_TO_DEVICE_TYPE_POWER_GUIDANCE = 'powerGuidance';
export const SEND_TO_DEVICE_TYPE_SPORTING_EVENT = 'sporting-event';

export const SEND_TO_DEVICE_COURSE_COORDINATE_SYSTEM_WGS84 = 'WGS84';
export const SEND_TO_DEVICE_COURSE_COORDINATE_SYSTEM_GCJ02 = 'GCJ02';

export const LAUNCH_GE_PREFERENCE = 'LaunchGEPreference';
